module.exports = __webpack_public_path__ + "img/c6.f570f35f.png";